import { __decorate, __metadata } from "tslib";
import { IsEnum, IsOptional, IsUUID } from 'class-validator';
import { LineItemType } from '../../type/order';
export class CanSkipPaymentRequest {
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CanSkipPaymentRequest.prototype, "courtSystemId", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], CanSkipPaymentRequest.prototype, "orderId", void 0);
__decorate([
    IsEnum(LineItemType),
    __metadata("design:type", String)
], CanSkipPaymentRequest.prototype, "lineItemType", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], CanSkipPaymentRequest.prototype, "userId", void 0);
